import { render, staticRenderFns } from "./InboundMappings.vue?vue&type=template&id=286f5f00&"
import script from "./InboundMappings.vue?vue&type=script&lang=ts&"
export * from "./InboundMappings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports